import { InputLabel } from '@mui/material';
import { BaseInputLabelProps } from './BaseInputLabel.types';

/**
 * The `InputLabel` control that handles labels with MUI styling for inputs
 * like the select. This control handles the separation between our controls
 * that wrap MUI and MUI itself so that we can mock away MUI.
 *
 * @param id - {@link BaseInputLabelProps.id id} description.
 * @param classes - {@link BaseInputLabelProps.classes classes} description.
 * @param children - {@link BaseInputLabelProps.children children} description.
 */
export const BaseInputLabel = ({
    id,
    classes,
    children,
}: BaseInputLabelProps) => {
    return (
        <InputLabel
            id={id}
            classes={{
                ...classes,
            }}
        >
            {children}
        </InputLabel>
    );
};